import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const LoaderOverlay = ({ isLoading, children }) => {
  return (
    <Box position="relative">
      {isLoading && (
        <Box
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          bgcolor="rgba(255, 255, 255, 0.7)"
          zIndex={9999999}
        >
          <CircularProgress />
        </Box>
      )}
      {children}
    </Box>
  );
};

export default LoaderOverlay;
